import {GEO_LOCATION_KICK_REASONS, KICK_REASONS} from "../player_messages_service/player_messages_consts";
import {Check} from "@sparkware/app-utils";

export function getIfKnownKickReason(reasonId: string): boolean {
    return KICK_REASONS.includes(reasonId);
}

export function getIfKnownGeoLockationKickReason(reasonId: string): boolean {
    return GEO_LOCATION_KICK_REASONS.includes(reasonId);
}

export function shouldFireGeoKick(data):boolean {
    const failReasonIDFromMainProxy = !Check.isNullOrUndefined(data.KickReason) && data.KickReason !== 0;
    const failReasonIDFromFirebase = !Check.isNullOrUndefined(data.ReasonID) && data.ReasonID !== 0;
    const hasTroubleShooterMessage = !Check.isNullOrUndefined(data.TroubleshooterMessages) && (!Check.isArray(data.TroubleshooterMessages) || data.TroubleshooterMessages.length > 0);


    return failReasonIDFromFirebase || failReasonIDFromMainProxy|| hasTroubleShooterMessage;
}